package com.ai.mitra.domain.use_cases

import com.ai.mitra.domain.model.ChatMessage
import com.ai.mitra.domain.respository.GeminiRepository
import org.koin.core.component.KoinComponent


class GetAllMessageByGroupIdUserCase(private val geminiRepository: GeminiRepository) : KoinComponent {
    suspend fun getMessageListByGroupId(groupId:String): List<ChatMessage> {
        return geminiRepository.getMessageListByGroupId(groupId)
    }

}